export default __webpack_public_path__ + "static/media/Wanja_sur.a69c2b28.jpg";